import { logger as LOG } from '@sweetgreen/garnish';

const name = 'Reorder';

export const reorderLogger = LOG.extend(name);

LOG.disable(name);
